import React from 'react'

export const RatingNa: React.FC = () => {
  return <span className='color-pro-steel-grey-400'>N/A</span>
}
